<template>
    <div class="row">
        <client-snappy-table
                :table-data="tableData"
                :columns="['name', 'actions']"
                :headings="['Name', 'Actions']"
                :templated-slot-names="['actions']"
                record-type="Document Templates"
        >
            <template #actions="{ row }">
                <div @click="handleCreate(row)" class="button btn-primary">
                    Create
                </div>
                <a :href="'/?p='+row.product_id" class="button">
                    View Details
                </a>
            </template>
        </client-snappy-table>
    </div>
</template>

<script>
    import ClientSnappyTable from '../../components/ClientSnappyTable';

    export default {
        name: 'document-templates-table',
        components: {ClientSnappyTable},
        methods: {
            handleCreate(row) {
                let encoded = encodeURI('id=' + row.id + '&n=' + row.name);
                window.location.href = "new/?sk_token=" + btoa(encoded);
            }
        },
        data() {
            return {

            };
        },
        props: {
            tableData: {
                type: Array,
                required: true
            }
        }
    }
</script>